import { atom, selector } from "recoil";
import { LOCAL_STORAGE_COMPLETED_LEVELS } from "../helpers/consts";

const getDefaultProgressFromLocalStorage = () => {
  const knownValue = window.localStorage.getItem(
    LOCAL_STORAGE_COMPLETED_LEVELS
  );

  if (knownValue) {
    return JSON.parse(knownValue);
  }

  return {};
};

const completedLevelsAtom = atom({
  key: "completedLevelsAtom",
  default: getDefaultProgressFromLocalStorage(),
});

export const completedLevelsSelector = selector({
  key: "completedLevelsSelector",
  get: ({ get }) => {
    return get(completedLevelsAtom);
  },
  set: ({ set }, newValue) => {
    //Save this as a string
    const savedValue = JSON.stringify(newValue);
    window.localStorage.setItem(LOCAL_STORAGE_COMPLETED_LEVELS, savedValue);
    set(completedLevelsAtom, newValue);
  },
});
